export default __webpack_public_path__ + "static/media/career-page.45d2defc.svg";